import AlertService from "./AlertService.js";

export default AlertService.create({});
